// extracted by mini-css-extract-plugin
export var active = "_6x-b";
export var activeIndicator = "_6x-6";
export var animate = "_6x-a";
export var disabled = "_6x-c";
export var flat = "_6x-1";
export var fullWidth = "_6x-3";
export var lg = "_6x-9";
export var md = "_6x-8";
export var redoButtonTabGroup = "_6x-0";
export var sm = "_6x-7";
export var tabButton = "_6x-4";
export var tabButtonsContainer = "_6x-2";
export var xs = "_6x-5";